export default "<p>\r\n  facial-Recognition Coming Soon\r\n</p>\r\n"